import BaseCollapse from "@reusables/BaseCollapse";
import BaseMaterialCheckbox from "@reusables/BaseMaterialCheckbox";

interface SelectableImportCategoryProps {
    text: string;
    icon: JSX.Element;
    isSelected: boolean;
    onChange: (value: boolean) => void;
    children?: JSX.Element;
}

export default function SelectableImportCategory(props: SelectableImportCategoryProps) {
    return (
        <BaseCollapse isOpen={props.isSelected} onOpenChange={props.onChange}>
            <BaseCollapse.Header className="flex flex-row items-center justify-between space-x-2">
                <div>{props.icon}</div>
                <div className="grow">{props.text}</div>
                <div className="grow text-right">
                    <BaseMaterialCheckbox
                        checked={props.isSelected}
                        onChange={(e, v) => props.onChange(v)}
                        checkedClassName="bg-purple-500"
                    />
                </div>
            </BaseCollapse.Header>
            {props.children && <BaseCollapse.Body>{props.children}</BaseCollapse.Body>}
        </BaseCollapse>
    );
}
